import myDownloadsComponent from './myDownloads.component';
import infoPopupComponent from './infoPopup/infoPopup.component';

export default angular.module('app.myDownloads', [])
	.component('myDownloads', myDownloadsComponent)
	.component('myDownloadInfo', infoPopupComponent)
	.name;
